module.exports = __webpack_public_path__ + "img/logo-avaliacao.24436aa8.svg";